<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  /** VCheckbox has no useful readonly; treat as non-interactive like disabled. */
  readonly: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const value = defineModel<string>()

function toBoolModel(raw: unknown): boolean {
  const normalized = String(raw ?? '')
    .trim()
    .toLowerCase()
  return normalized === 'true' || normalized === '1' || normalized === 'yes'
}

/** Преобразуем типы **/
const currentValue = computed({
  set: (newValue: boolean | string) => {
    if (typeof newValue === 'boolean') {
      value.value = String(newValue)
      return
    }
    value.value = toBoolModel(newValue) ? 'true' : 'false'
  },
  get: () => toBoolModel(value.value),
})
</script>

<template>
  <VRadioGroup
    v-model="currentValue"
    inline
    class="invent-bool-type-field"
    :label="$t('itf.default_value') ? '' : label"
    :disabled="disabled || props.readonly"
    :loading="loading"
    density="comfortable"
  >
    <VRadio :value="true">{{ $t('itf.yes') }}</VRadio>
    <VRadio :value="false">{{ $t('itf.no') }}</VRadio>
  </VRadioGroup>
</template>

<style scoped>
/** Убираем фиксированный размер контрола, чтобы Да/Нет не перекрывали радио. */
.invent-bool-type-field :deep(.v-selection-control--density-comfortable) {
  --v-selection-control-size: auto;
}

/** Отступ между вариантами Да/Нет в строчном режиме. */
.invent-bool-type-field :deep(.v-selection-control-group--inline) {
  gap: 12px;
}
</style>
